import { useCallback, useEffect, useState } from "react";
import { NavLink, Outlet, Link, useLocation } from "react-router-dom";
import { AdminGuard } from "./AdminGuard";
import { fetchAdminContacts } from "./api";
import { useAdminLive } from "./hooks/useAdminLive";
import "./admin.css";

const NAV = [
  { to: "/admin/dashboard", label: "Dashboard" },
  { to: "/admin/users", label: "Users" },
  { to: "/admin/regions", label: "Regions" },
  { to: "/admin/pixels", label: "Pixels" },
  { to: "/admin/contacts", label: "Contacts" },
  { to: "/admin/referrals", label: "Empfehlungen" },
] as const;

export function AdminLayout() {
  const { connectionCount } = useAdminLive();
  const { pathname } = useLocation();
  const [newContactCount, setNewContactCount] = useState(0);

  const loadNewContactCount = useCallback(async () => {
    try {
      const contacts = await fetchAdminContacts();
      setNewContactCount(contacts.filter((contact) => contact.status === "new").length);
    } catch {
      // The guard handles authentication errors; keep navigation usable meanwhile.
    }
  }, []);

  useEffect(() => {
    void loadNewContactCount();
    const timer = window.setInterval(() => void loadNewContactCount(), 30_000);
    return () => window.clearInterval(timer);
  }, [loadNewContactCount, pathname]);

  return (
    <AdminGuard>
      <div className="admin-shell">
        <aside className="admin-sidebar">
          <div className="admin-brand">
            <span className="admin-brand-title">DWIK Admin</span>
            <span className="admin-brand-sub">Operations</span>
          </div>

          <nav className="admin-nav">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `admin-nav-link${isActive ? " active" : ""}`
                }
              >
                {item.label}
                {item.to === "/admin/contacts" ? ` (${newContactCount})` : ""}
              </NavLink>
            ))}
          </nav>

          <div className="admin-sidebar-footer">
            <div className="admin-live-pill">
              <span className="admin-live-dot" />
              {connectionCount} live connection
              {connectionCount === 1 ? "" : "s"}
            </div>
            <Link to="/start" target="_blank" rel="noopener noreferrer" className="admin-site-link">
              ← Public site
            </Link>
          </div>
        </aside>

        <main className="admin-main">
          <Outlet />
        </main>
      </div>
    </AdminGuard>
  );
}
